import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { siteInfo } from "@/mocks/site";
import { formatViews } from "@/utils/format";

const heroStats = [
  { value: "183+", label: "已收录话题" },
  { value: "12 篇", label: "日均更新" },
  { value: "260万", label: "累计围观" },
];

export default function HeroSection() {
  const spotlight = articles[0];

  return (
    <section className="relative overflow-hidden bg-background-50 pt-24 md:pt-28 pb-14 md:pb-20">
      <div className="pointer-events-none absolute -top-20 -left-24 w-72 h-72 rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute top-40 -right-20 w-80 h-80 rounded-full bg-accent-100/50 blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        <div className="lg:col-span-7 animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-label border border-primary-200">
            <span className="relative flex w-2 h-2">
              <span className="absolute inline-flex w-full h-full rounded-full bg-primary-400 animate-ping-slow"></span>
              <span className="relative inline-flex w-2 h-2 rounded-full bg-primary-500"></span>
            </span>
            今日已更新 · 全网热点正在讨论中
          </span>

          <h1 className="mt-5 font-heading font-black text-3xl md:text-5xl leading-tight text-foreground-950">
            {siteInfo.brand}
            <span className="block mt-2 text-primary-600">把热闹看明白</span>
          </h1>

          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
            全网热点聚合与观察站。{siteInfo.tagline}——我们把正在被讨论的事整理成有条理的观察文章，让你在围观的同时，也能看清一件事情的来龙去脉。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
              看今日热榜
            </a>
            <a
              href="#topics"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300/80 text-foreground-800 text-sm font-label font-medium hover:border-accent-400 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-layout-grid-line w-4 h-4 flex items-center justify-center"></i>
              浏览话题分类
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-3 gap-4 max-w-lg">
            {heroStats.map((stat) => (
              <div key={stat.label} className="border-l-2 border-accent-400 pl-3">
                <dt className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  {stat.value}
                </dt>
                <dd className="mt-0.5 text-xs text-foreground-500 font-label">
                  {stat.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative rounded-lg overflow-hidden bg-background-200 w-full h-[340px] md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20flat%20vector%20illustration%20of%20a%20colorful%20crowd%20of%20tiny%20stylized%20people%20gathered%20in%20front%20of%20a%20large%20glowing%20screen%2C%20warm%20coral%20red%20amber%20and%20fresh%20green%20palette%2C%20celebratory%20social%20atmosphere%2C%20soft%20grain%20texture%2C%20editorial%20poster%20style%2C%20clean%20composition&width=900&height=1100&seq=gua-hero-portrait&orientation=portrait"
              alt="围观的网民聚集在发光屏幕前的抽象插画"
              title="热瓜前线 全网热点围观"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
          </div>

          {spotlight && (
            <Link
              to={`/article/${spotlight.id}`}
              className="absolute -bottom-5 left-4 right-4 md:left-6 md:right-8 block rounded-lg bg-background-50 border border-background-200 p-4 cursor-pointer hover:border-primary-300 transition-colors animate-float"
            >
              <div className="flex items-center gap-2 text-xs font-label text-primary-600">
                <i className="ri-fire-fill w-3.5 h-3.5 flex items-center justify-center"></i>
                当前最热 · 热度 {spotlight.heat}
              </div>
              <p className="mt-1.5 font-heading font-bold text-sm text-foreground-900 line-clamp-2">
                {spotlight.title}
              </p>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500 font-label">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  {formatViews(spotlight.views)}
                </span>
                <span>{spotlight.categoryName}</span>
              </div>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}